module.exports = ".elastic-dialog-container {\n  position: relative;\n}\n\n.header-cell-text {\n  color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/match/elastic-dialog.component.css
// module id = ./src/app/match/elastic-dialog.component.css
// module chunks = main